import { getTagActionSize, Tag, TAG_HEIGHT, TagAvatar } from '../../Tag'

function UserTag({
  avatarColor,
  avatarSrc,
  height = TAG_HEIGHT.height32,
  name,
  ...restProps
}) {
  return (
    <Tag
      {...restProps}
      beforeContent={
        <TagAvatar
          color={avatarColor}
          size={getTagActionSize(height)}
          src={avatarSrc}
          text={name}
        />
      }
      height={height}
      text={name}
    />
  )
}

export default UserTag
